import React, { useEffect, useRef, useState, useCallback } from "react";
import api from "../lib/api.ts";
import VehicleCard from "../components/VehicleCard.jsx";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";

const BuyNowVehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(1000);
  const [wishlistData, setWishlistData] = useState([]);
  const { user } = useAuth();
  const { language, translate } = useLanguage();
  const isRTL = language === "ar";

  const fetchVehicles = useCallback(async () => {
    try {
      const response = await api.get(
        `/products/paginated?page=${currentPage}&limit=${pageSize}&type=buy-now&filters[showExpiredBuyNow]=0`
      );
      console.log("Fetched vehicles:", response.data.data);
      setVehicles(response.data.data);

      setLoading(false);
    } catch (error) {
      console.error("Error fetching vehicles:", error);
      setLoading(false);
    }
  }, [currentPage, pageSize]);

  // Fetch wishlist data
  useEffect(() => {
    const fetchWishlist = async () => {
      if (!user?.id) {
        setWishlistData([]);
        return;
      }

      try {
        const response = await api.get("/wishlist");
        const wishlist = response.data?.data || response.data;

        if (wishlist && Array.isArray(wishlist)) {
          setWishlistData(wishlist);
        } else {
          setWishlistData([]);
        }
      } catch (error) {
        console.error("Error fetching wishlist:", error);
        setWishlistData([]);
      }
    };

    fetchWishlist();
  }, [user?.id]);

  // Initial fetch
  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  return (
    <div

      dir={isRTL ? "rtl" : "ltr"}
      lang={language}
    >
      {/* <h1 className='text-3xl text-white font-bold text-center py-8'>
        {translate("buyNowPage.title")}
      </h1> */}

      <div className="w-full bg-primary border-b-2 border-gray px-6 py-4 mb-8 min-h-[120px]">
        <div className="max-w-[1600px] mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {translate("buyNowPage.title")}
          </h1>
          <p className="text-gray-400 max-w-2xl text-sm md:text-base">
            {translate("buyNowPage.description")}
          </p>
        </div>
      </div>

      <div
        className='max-w-7xl mx-auto'
        dir={isRTL ? "rtl" : "ltr"}
        lang={language}
      >
        {loading ? (
          <div className='flex justify-center items-center h-64'>
            <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500'></div>
          </div>
        ) : vehicles.length === 0 ? (
          <div className='flex flex-col items-center justify-center h-64 text-gray-500 text-center px-4'>
            <div className='text-6xl mb-4'>🚗</div>
            <h2 className='text-xl font-semibold mb-2'>
              {translate("buyNowPage.emptyTitle")}
            </h2>
            <p className='max-w-2xl'>
              {translate("buyNowPage.emptyDescription")}
            </p>
          </div>
        ) : (
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-4'>
            {vehicles.map((vehicle) => {
              const vehicleMappedData = {
                id: vehicle.id,
                title: vehicle.name,
                slug: vehicle.slug,
                lotNo: vehicle.lotNumber,
                runNo: vehicle.auctionLanesVehicles?.[0]?.runNo || "-",
                condition: vehicle.primaryDamageType?.name || "-",
                miles: vehicle.mileage || "-",
                fuelType: vehicle?.fuelType?.name || "-",
                engineSize: vehicle?.engine?.name || "-",
                startBidding: vehicle?.startingBid || 0,
                latestBid: vehicle?.currentBid || 0,
                cylinder: vehicle?.cylinder?.name || "-",
                transmission: vehicle?.TransmissionType?.name || "-",
                driveType: vehicle?.DriveLineType?.name || "-",
                bodyType: vehicle?.BodyType?.name || "-",
                specifications: vehicle?.specifications || "-",
                seatType: vehicle?.seatType || "-",
                exteriorColor: vehicle.ExteriorColor?.name || "-",
                interiorColor: vehicle.InteriorColor?.name || "-",
                image: vehicle.images?.[0]?.imageUrl || "/car-placeholder.png",
                auctionLaneId:
                  vehicle.auctionLanesVehicles?.[0]?.auctionLane?.id || "-",
                bidIncrement: vehicle?.bidIncrement || 0,
                isRunAndDrive: vehicle.keys || false,
                highlights: vehicle.Highlight
                  ? [
                    {
                      name: vehicle.Highlight?.name || "-",
                      bgColor: vehicle?.Highlight?.bgColor || "-",
                      textColor: vehicle?.Highlight?.textColor || "-",
                    },
                  ]
                  : [],
                productStatus: vehicle.ProductStatus?.name || "-",
                buyNowPrice: vehicle.buyNowPrice || "-",
                buyNowEndTime: vehicle.buyNowEndTime || "-",
              };
              return (
                <VehicleCard
                  key={vehicle.id}
                  vehicle={vehicleMappedData}
                  wishlistData={wishlistData}
                />
              );
            })}
          </div>

        )}
      </div>
    </div>
  );
};

export default BuyNowVehicles;
